import { render, staticRenderFns } from "./SalonStylistReviewPrompt.vue?vue&type=template&id=451a95ea&scoped=true&"
import script from "./SalonStylistReviewPrompt.vue?vue&type=script&lang=js&"
export * from "./SalonStylistReviewPrompt.vue?vue&type=script&lang=js&"
import style0 from "./SalonStylistReviewPrompt.vue?vue&type=style&index=0&id=451a95ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a95ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText})
